export default "__VITE_ASSET__SamPJwbv__"